import * as React from 'react'
import {useState} from 'react'

import "../assets/scss/main.scss"
import 'react-calendar/dist/Calendar.css'

import {useWpContext} from "../components/context/XWpProvider";
import {useQuery} from "@apollo/client";
import {Query, QueryFullDaysArgs} from "../graphql/generated/graphql-main";
import {mainGqlTemplates} from "../utils/gql-client";
import dayjs from "dayjs";
import Calendar from "react-calendar";
import IsBetween from "dayjs/plugin/isBetween";

dayjs.extend(IsBetween)

/**
 *
 * @param props
 * @constructor
 */
export const AvailableBookings = (props: XProps) => {
    const xWpCtx = useWpContext()
    const { data: availData } = xWpCtx

    console.info(`language = ${window.navigator.language}`)

    const [startDate, setStartDate] = useState<Date>(new Date());

    // get booked days for all 3 cabin types
    const {data, error, loading} = useQuery<Query, QueryFullDaysArgs>(
        mainGqlTemplates.GET_BOOKED_DAYS,
        {
            variables: {
                month: dayjs(startDate).format('YYYYMM')
            },
            fetchPolicy: "no-cache"
        })

    // get closed periods
    const {data: closedData, error: closedError, loading: closedLoading} = useQuery<Query>(
        mainGqlTemplates.GET_CLOSED_PERIODS, {
            fetchPolicy: "cache-and-network"
        })

    // shortcuts prepared for null-safety
    const bookedStilts = (data?.fullDays?.stilts || []) as string[]
    const bookedCabanitas = (data?.fullDays?.cabanitas || []) as string[]
    const bookedKaboum = (data?.fullDays?.kaboum || []) as string[]

    const closedStilts = (closedData?.getClosedPeriods?.stilts || []) as string[]
    const closedCabanitas = (closedData?.getClosedPeriods?.cabanitas || []) as string[]
    const closedKaboum = (closedData?.getClosedPeriods?.kaboum || []) as string[]

    // e.g. 2020-12-15::2021-05-20
    const splitRange = (range: string): string[] => range.split('::')

    /**
     * Whether a date is withing range represented like [2020-12-15, 2021-05-20] == [from, to]
     * - https://day.js.org/docs/en/plugin/is-between
     *
     * @param date
     * @param range
     */
    const inRange = (date: Date, range: string[]): boolean => {
        return dayjs(date).isBetween(range[0], range[1], null, '[]')
    }

    // ALL related to low/high season pricing
    const isHighSeason = (date: Date): Boolean => {
        const dow = `${date.getDay()}`
        const ymd_date = dayjs(date).format("YYYYMMDD")

        const isHighDay = availData.highDays.includes(dow)

        let inHighRange = false
        for (const range of availData.highRanges) {
            if (ymd_date >= range.xstart && ymd_date <= range.xend) {
                inHighRange = true
                break
            }
        }
        return isHighDay || inHighRange
    }

    return (
        // https://tailwindcss.com/docs/justify-items#center
        <div id="cnx-standard" className="x-calendar grid grid-cols-3 gap-x-8 justify-items-center">
            {/* CABINS ON STILTS */}
            <div className="x-sub-calendar mb-8 col-span-3 md:col-span-1">
                <div className="mb-2 kab-type-title">
                    {xWpCtx.texts.stilts}
                </div>
                <Calendar
                    className="w-full"
                    minDate={new Date()}
                    activeStartDate={startDate}
                    showNeighboringMonth={false}
                    onActiveStartDateChange={(props1) => {
                        console.info(props1)
                        setStartDate(props1.activeStartDate)
                    }}
                    tileDisabled={({activeStartDate, date, view}) => {
                        for (const strRange of closedStilts) {
                            if (inRange(date, splitRange(strRange)))
                                return true
                        }

                        return date.getMonth() == startDate.getMonth() &&
                            bookedStilts.includes(date.getDate().toString())
                    }}
                    tileContent={(tileProps) => {
                        return <div className="pt-2 cabin-pricing">
                            {isHighSeason(tileProps.date)
                                ? availData.priceStilts?.high
                                : availData.priceStilts?.low}
                            <span>&nbsp;$</span>
                        </div>
                    }}
                />
            </div>

            {/* CABANITAS */}
            <div className="x-sub-calendar mb-8 col-span-3 md:col-span-1">
                <div className="mb-2 kab-type-title">
                    {xWpCtx.texts.cabanitas}
                </div>
                <Calendar
                    className="w-full"
                    minDate={new Date()}
                    activeStartDate={startDate}
                    showNeighboringMonth={false}
                    onActiveStartDateChange={(props1) => {
                        console.info(props1)
                        setStartDate(props1.activeStartDate)
                    }}
                    tileDisabled={({activeStartDate, date, view}) => {
                        for (const strRange of closedCabanitas) {
                            if (inRange(date, splitRange(strRange)))
                                return true
                        }

                        return date.getMonth() == startDate.getMonth() &&
                            bookedCabanitas.includes(date.getDate().toString())
                    }}
                    tileContent={(tileProps) => {
                        return <div className="pt-2 cabin-pricing">
                            {isHighSeason(tileProps.date)
                                ? availData.priceCabanitas?.high
                                : availData.priceCabanitas?.low}
                            <span>&nbsp;$</span>
                        </div>
                    }}
                />
            </div>

            {/* KABOUM */}
            <div className="x-sub-calendar mb-8 col-span-3 md:col-span-1">
                <div className="mb-2 kab-type-title">
                    {xWpCtx.texts.kaboum}
                </div>
                <Calendar
                    className="w-full"
                    minDate={new Date()}
                    activeStartDate={startDate}
                    showNeighboringMonth={false}
                    onActiveStartDateChange={(props1) => {
                        console.info(props1)
                        setStartDate(props1.activeStartDate)
                    }}
                    tileDisabled={({activeStartDate, date, view}) => {
                        for (const strRange of closedKaboum) {
                            console.info(strRange)
                            if (inRange(date, splitRange(strRange)))
                                return true
                        }

                        return date.getMonth() == startDate.getMonth() &&
                            bookedKaboum.includes(date.getDate().toString())
                    }}
                    tileContent={(tileProps) => {
                        return <div className="pt-2 cabin-pricing">
                            {isHighSeason(tileProps.date)
                                ? availData.priceKaboum?.high
                                : availData.priceKaboum?.low}
                            <span>&nbsp;$</span>
                        </div>
                    }}
                />
            </div>
        </div>
    )
}


type XProps = {}